module.exports = __webpack_public_path__ + "img/xiehuodian.a5ffd4f7.png";